module.exports = "<select\n    ng-model=\"VatFilterCtrl.vatRate\"\n    ng-options=\"item for item in VatFilterCtrl.vatRates\"\n></select>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/filters/vat-filter/vat-filter.html
// module id = 552
// module chunks = 0